"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityUpdateTransformGrouping = void 0;
const swap_buffer_layout_1 = require("./swap-buffer-layout");
/**
 * @public
 * A grouping of a graphics component with its renderer and transform.
 */
class EntityUpdateTransformGrouping {
    constructor(graphicsComponent, componentRenderer, transformComponent, transformRenderer) {
        this.graphicsComponent = graphicsComponent;
        this.componentRenderer = componentRenderer;
        this.transformComponent = transformComponent;
        this.transformRenderer = transformRenderer;
    }
    drawUpdateGroup(entities, updateArg) {
        const transformRenderer = this.transformRenderer;
        const componentRenderer = this.componentRenderer;
        const graphicsComponent = this.graphicsComponent;
        const transformComponent = this.transformComponent;
        const entityBufferStore = this.componentRenderer.sharedState.entityBuffers;
        const groupId = graphicsComponent.transform.groupId;
        for (let i = 0, iEnd = entities.length; i < iEnd; ++i) {
            const entity = entities[i];
            if (entity.isFiltered) {
                continue;
            }
            const entityBufferLayout = entityBufferStore.getLayout(entity, groupId);
            // if the entity has buffers, use them
            (0, swap_buffer_layout_1.swapBufferLayout)(graphicsComponent, entityBufferLayout);
            if (graphicsComponent.transform.isTransformRequired(entity, updateArg)) {
                // transform
                transformRenderer.onBeforeDraw();
                graphicsComponent.transform.setOutputBuffers(entity, transformRenderer);
                transformComponent.performTransform(entity, transformRenderer, updateArg);
                transformRenderer.onAfterDraw();
            }
            // gc update
            componentRenderer.onBeforeDraw();
            graphicsComponent.onBeforeUpdate(componentRenderer, updateArg);
            graphicsComponent.update(entity, componentRenderer, updateArg);
            componentRenderer.onAfterDraw();
            // swap back
            (0, swap_buffer_layout_1.swapBufferLayout)(graphicsComponent, entityBufferLayout);
        }
    }
}
exports.EntityUpdateTransformGrouping = EntityUpdateTransformGrouping;
//# sourceMappingURL=entity-update-transform-grouping.js.map